import 'reflect-metadata';
import 'bootstrap';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { keepPreviousData, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';

import '@shared/libs/i18n/index';
import { HelmetProvider } from 'react-helmet-async';
import { createAppRouter } from '@my-pages/routing/utils/router-utils.tsx';
import useApplicationStore from '@my-pages/stores/useApplicationStore.tsx';
import ApplicationProvider from '@my-pages/providers/ApplicationProvider.tsx';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            placeholderData: keepPreviousData,
            retry: 2,
        },
    },
});

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
}

export const router = createAppRouter(queryClient);

export const App = () => {
    useApplicationStore.getState().initApp();
    return (
        <HelmetProvider>
            <QueryClientProvider client={queryClient}>
                <ApplicationProvider>
                    <RouterProvider router={router} />
                    <ReactQueryDevtools
                        initialIsOpen={false}
                        buttonPosition={'bottom-right'}
                    />
                </ApplicationProvider>
            </QueryClientProvider>
        </HelmetProvider>
    );
};
